import { render, staticRenderFns } from "./hotelRoomType.vue?vue&type=template&id=102005f2&scoped=true&"
import script from "./hotelRoomType.vue?vue&type=script&lang=js&"
export * from "./hotelRoomType.vue?vue&type=script&lang=js&"
import style0 from "./hotelRoomType.vue?vue&type=style&index=0&id=102005f2&prod&scoped=true&lang=css&"
import style1 from "./hotelRoomType.vue?vue&type=style&index=1&id=102005f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102005f2",
  null
  
)

export default component.exports